import { axiosPartnerInstance } from "../helpers/axiosInstance";
import { AppCache } from "../helpers/myStorage";

export const licencesList = (data = {}) => {
  return axiosPartnerInstance.get("/admin/licenseList", {
    params: {
      ...data,
      language: AppCache.getCurrentLanguage()
    }
  });
};

export const getLicence = ({ id }) => {
  return axiosPartnerInstance.get("/admin/license", {
    params: {
      licenseId: id,
      language: AppCache.getCurrentLanguage()
    }
  });
};

export const getLicenceUuid = (uuid) => {
  return axiosPartnerInstance.get("/Admin/licence", { params: { uuid } });
};

export const addLicence = (data) => {
  return axiosPartnerInstance.post("/Admin/licence", data);
};

export const updateLicence = (data) => {
  return axiosPartnerInstance.post("/Admin/licence", data);
};


export const deleteLicence = (id) => {
  return axiosPartnerInstance.delete("/Admin/licence", { params: { id } });
};

export const resetPassword = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: "ok" });
    }, 2000);
  });
};

export const unSuspendLicence = (licenceId) => {
  return axiosPartnerInstance.post("/Admin/unsuspendLicence", { licenceId, uuid: "" });
};

const licenceService = {
  licencesList,
  //getLicense,
  getLicence,
  addLicence,
  updateLicence,
  deleteLicence,
  resetPassword,
  getLicenceUuid,
  unSuspendLicence,
};

export default licenceService;
